module.exports = __webpack_public_path__ + "static/media/img_sendero.4b30fdeb.jpg";